module.exports = __webpack_public_path__ + "img/qualityPlatform_数据反馈过程.b8c543b7.png";